import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/footer.css';

const FOOTER_LINKS = [
  { to: '/company', label: 'Company' },
  { to: '/services', label: 'Services' },
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/insights', label: 'Insights' },
  { to: '/board', label: 'Board' },
  { to: '/contact', label: 'Contact' },
];

const Footer = () => (
  <footer className="site-footer">
    <div className="site-footer__inner">
      <div className="site-footer__brand">
        <Link to="/" className="site-footer__logo" aria-label="EZYLAB 홈">
          <img src="/images/logo.svg" alt="EZYLAB" />
        </Link>
        <p className="site-footer__tagline">
          아이디어를 완성도 높은 제품으로. 이지랩은 기획부터 개발·운영까지 함께합니다.
        </p>
      </div>

      <nav className="site-footer__nav" aria-label="푸터 메뉴">
        {FOOTER_LINKS.map((l) => (
          <Link key={l.to} to={l.to} className="site-footer__link">{l.label}</Link>
        ))}
        <a
          href="https://lotto.ezylab.co.kr"
          target="_blank"
          rel="noopener noreferrer"
          className="site-footer__link"
        >
          포춘로또
        </a>
        <a
          href="https://salarynote.ezylab.co.kr"
          target="_blank"
          rel="noopener noreferrer"
          className="site-footer__link"
        >
          월급노트
        </a>
      </nav>
    </div>

    <div className="site-footer__bottom">
      <div className="site-footer__inner site-footer__inner--bottom">
        <p className="site-footer__copy">© 2025 EZYLAB. All rights reserved.</p>
        <Link to="/privacy" className="site-footer__link">개인정보 처리방침</Link>
        <Link to="/contact" className="site-footer__contact">문의하기</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
